export default {
    constant_vaccination_1: 'None',
    constant_vaccination_2: 'Mean',
    constant_vaccination_3: 'Low',
    constant_vaccination_4: 'High',
};
